// Home
export const home_HomeUrl = '/';
export const home_About = '/about';
export const home_Trainings = '/trainings';
export const home_ReleaseNotes = '/releasenotes';

// Search
export const searchAreaUrl = '/search';
export const search_endCustomerUrl = `${searchAreaUrl}/consumer`;
export const search_productUrl = `${searchAreaUrl}/product`;

// Register
export const registerAreaUrl = '/register';
export const register_endCustomerUrl = `${registerAreaUrl}/consumer`;
export const register_unitUrl = `${registerAreaUrl}/unit`;

// Developers
const developersAreaUrl = '/developers';
export const developers_componentsUrl = `${developersAreaUrl}/components`;
export const developers_typographyPageUrl = `${developersAreaUrl}/typography`;
export const developers_DeploymentAlertUrl = `${developersAreaUrl}/managedeploymentalert`;

// Errors
const errorsAreaUrl = `/errors`;
/** /PC/errors/authentication */
export const errors_AuthenticationUrl = `${errorsAreaUrl}/authentication`;
/** /PC/errors/authorization */
export const errors_AuthorizationUrl = `${errorsAreaUrl}/authorization`;

// Administration
export const administrationAreaUrl = '/administration';
export const administration_uploadProductIndividualUrl = `${administrationAreaUrl}/UploadProductIndividual`;

// Not Found
export const notFoundUrl = '/notfound';

// Maintenance planner
export const maintenancePlannerUrl = '/MaintenancePlanner';

// Fleet Operations widget
export const fleetOperationsUrl = '/FleetOperations';

export const root = 'root';

//Unit
export const unitOverViewAreaUrl = '/unitoverview';
export const unitAreaUrl = '/unit';
export const unitId = 'unitId';
export const unitRelativeUrl = `:unitId`; // TODO rename to :publicUnitId?
export const resolvedUnitIds = 'resolvedUnitIds';

export const unitAddEndCustomer = 'addendcustomer';
export const unitProductInOperation = 'productinoperation';
export const unitCommissioning = 'commissioning';
export const unitEdit = 'edit';
export const unitEditEndCustomer = 'endcustomer';
export const unitEditEndCustomerConnect = 'connect';
export const unitRelocateTo = 'relocateto';
export const unitAddEndCustomerPageUrl = `${unitAreaUrl}/${unitAddEndCustomer}`;
export const unitProductInOperationPageUrl = `${unitAreaUrl}/${unitProductInOperation}`;
export const unitCommissioningPageUrl = `${unitAreaUrl}/${unitCommissioning}`;
export const addEndCustomerPageWizardUrl = `${unitAddEndCustomerPageUrl}/${unitRelativeUrl}`;
export const productInOperationWizardPageUrl = `${unitProductInOperationPageUrl}/${unitRelativeUrl}`;
export const commissioningWizardPageUrl = `${unitCommissioningPageUrl}/${unitRelativeUrl}`;
export const unitEditPageUrl = `${unitAreaUrl}/${unitEdit}/${unitRelativeUrl}`;
export const unitEditEndCustomerPageUrl = `${unitAreaUrl}/${unitEditEndCustomer}/${unitRelativeUrl}/${unitEditEndCustomerConnect}`;
export const unitRelocateToPageUrl = `${unitAreaUrl}/${unitRelocateTo}/${unitRelativeUrl}`;

// Unit Overview
export const UnitOverviewPageUrl = `${unitOverViewAreaUrl}/${unitRelativeUrl}`;
export const UnitOverview_Configuration = 'configuration';
export const UnitOverview_DemoDealerUsage = 'demodealerusage';
export const unitOverview_DemoDealerUsage_Url = `${unitOverViewAreaUrl}/${unitRelativeUrl}/${UnitOverview_DemoDealerUsage}`;
export const UnitOverview_Diagnostic = 'diagnostic';
export const UnitOverview_Telematics = 'telematics';
export const UnitOverview_EndCustomer = 'endcustomer';
export const UnitOverview_EndCustomer_Url = `${UnitOverviewPageUrl}/${UnitOverview_EndCustomer}`;
export const UnitOverview_Information = 'information';
export const UnitOverview_Kits = 'kits';
export const UnitOverview_OperatingLocation = 'operatinglocation';
export const UnitOverview_OtherProducts = 'otherproducts';
export const UnitOverview_Variants = 'variants';
export const UnitOverview_Warranty = 'warranty';
export const unitOverviewEventLog = 'eventLog';
export const UnitOverview_EventLog_Url = `${UnitOverviewPageUrl}/${unitOverviewEventLog}`;
export const UnitOverview_Publications = 'publications';
export const UnitOverview_ServiceProtocols_old = 'service-protocols';
export const UnitOverview_ServiceAgreements_old = 'serviceagreements';
export const UnitOverview_ServiceArea = 'services';
export const UnitOverview_Services_ServiceProtocols = 'serviceprotocols';
export const UnitOverview_Services_ServiceAgreements = 'serviceagreements';
export const UnitOverview_Services_HealthChecks = 'healthchecks';
export const UnitOverview_Services_Repairs = 'repairs';
export const UnitOVerview_Services_ServiceContracts = 'servicecontracts';

export const UnitOverview_Information_Edit = `${UnitOverview_Information}/edit`;

// Driveline view
export const drivelineviewAreaUrl = '/drivelineview';
export const drivelineviewParam = ':id';
export const drivelineviewPageUrl = `${drivelineviewAreaUrl}/${drivelineviewParam}`;
export const drivelineviewWarranty = 'warranty';
export const drivelineviewVariants = 'variants';
export const drivelineviewComponentsAndSoftware = 'componentsandsoftware';
export const drivelineviewSoftwareParameters = 'softwareparameters';
export const drivelineviewServiceArea = 'services';
export const Drivelineview_Services_ServiceProtocols = 'serviceprotocols';
export const Drivelineview_Services_Repairs = 'repairs';

// Product Individual view
export const productIndividualviewAreaUrl = '/productindividualview';
export const productIndividualviewSNParam = ':serialnumber';
export const productIndividualSNParamName = 'serialnumber';
export const productIndividualviewSectionParam = ':section';
export const productIndividualviewPageUrl = `${productIndividualviewAreaUrl}/${productIndividualviewSNParam}/${productIndividualviewSectionParam}`;
export const productIndividualTechnical = 'technical';
export const productIndividualCampaigns = 'campaigns';
export const productIndividualClaims = 'claims';
export const productIndividualParts = 'parts';
export const productIndividualConfiguration = 'configuration';
export const productIndividualEventLog = 'eventlog';
export const productIndividualLogisticTrail = 'logistictrail';
export const productIndividualVstCodes = 'vstcodes';
export const productIndividualDocuments = 'documents';
export const productIndividualPolicy = 'policy';
export const productIndividualServiceArea = 'services';
export const ProductIndividual_Services_Repairs = 'repairs';
export const productIndividualEdit = `${productIndividualviewAreaUrl}/edit/${productIndividualviewSNParam}`;

// Order Info view
export const orderInfoArea = 'orderinfo';
export const orderInfoParam = ':id';
export const orderInfoPageUrl = `${orderInfoArea}/${orderInfoParam}`;

export const UNIT_ROUTES = {
	unitAddEndCustomer,
	unitProductInOperation,
	unitCommissioning,
	unitEdit,
	unitEditEndCustomer,
	unitRelocateTo,
} as const;

// Health Check
export const healthCheckArea = 'healthcheck';
export const healthCheckParam = ':healthCheckId';
export const unitPublicIdSearchParam = 'unitPublicId';
// have to use public id in the frontend, because internal id could be translated to hiloid
export const generateHealthCheckUrl = (unitPublicId: string) =>
	`/${healthCheckArea}/${healthCheckParam}?/generate?${unitPublicIdSearchParam}=${unitPublicId}`; // todo - unitPublicId => unitId?
export const healthCheckView = `/${healthCheckArea}/${healthCheckParam}/view`;

// Service Protocol
// Example route /serviceprotocol/34/generate&drivelineId=2232455
export const serviceProtocolArea = 'serviceprotocol';
export const serviceProtocolParam = ':serviceProtocolId';
export const generateServiceProtocolUrl = `${serviceProtocolArea}/${serviceProtocolParam}?/generate`;
export const serviceProtocolView = `${serviceProtocolArea}/${serviceProtocolParam}/view`;

// Service Contract
export const serviceContractArea = 'servicecontract';
export const connectServiceContractPath = 'connect';
export const connectServiceContractSearchParam = 'serviceContractId';
